import type React from 'react';
import { useTenderDetails } from '../../contexts/TenderDetailsContext';
import PresentationExportStep from './PresentationExportStep';
import WorkflowStep from './WorkflowStep';

const VisualPresentationsStep: React.FC = () => {
  const {
    canManageTender,
    openStep,
    setOpenStep,
    tender,
    validTenderId,
    handleGeneratePresentation,
    handleGeneratePdf,
    handleDownloadPresentation,
    handleDownloadPdf,
    handleResetPresentation,
    handleResetPdf,
    isGeneratingPresentation,
    isGeneratingPdf,
    presentationError,
    pdfError,
    sectionsCount,
  } = useTenderDetails();

  if (!canManageTender) {
    return null;
  }

  return (
    <WorkflowStep
      stepNumber={11}
      expanded={openStep === 11}
      onChange={(_, isExpanded) => setOpenStep(isExpanded ? 11 : null)}
      title="Create Visual Presentations & PDFs"
      description="Transform your narrative into polished presentations and stylized PDFs."
      isComplete={!!tender.presentationLink || !!tender.pdfLink}
      optional={true}
    >
      <PresentationExportStep
        tenderId={validTenderId}
        onGeneratePresentation={handleGeneratePresentation}
        onGeneratePdf={handleGeneratePdf}
        onDownloadPresentation={handleDownloadPresentation}
        onDownloadPdf={handleDownloadPdf}
        onResetPresentation={handleResetPresentation}
        onResetPdf={handleResetPdf}
        isGeneratingPresentation={isGeneratingPresentation}
        isGeneratingPdf={isGeneratingPdf}
        presentationLink={tender.presentationLink}
        pdfLink={tender.pdfLink}
        presentationError={presentationError}
        pdfError={pdfError}
        hasSections={sectionsCount > 0}
      />
    </WorkflowStep>
  );
};

export default VisualPresentationsStep;
